import React from 'react';
import DownloadFromLibrary from '../../components/DownloadFromLibrary';

export function DownloadFullMatch() {
  return <DownloadFromLibrary />;
}

export default { DownloadFullMatch };
